import {useApi} from "@contexts/hooks/api/useApi.ts";
import {IGetEmpresasFilter} from "@components/empresas/endpoints/filters/IGetEmpresaFilter.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import _empresa_endpoints from "@components/empresas/endpoints/__empresa_endpoints.ts";
import {IEmpresa} from "@models/empresa/IEmpresa.ts";

export function useEmpresa() {
    const {Get} = useApi()
    const getEmpresas = (data: { filters: IGetEmpresasFilter, pagination: IPagination }) => {
        return Get(_empresa_endpoints['get-empresas'](data))
    }

    const createEmpresa = (data: Pick<IEmpresa, 'nome' | 'cnpj' | 'nroFilial'>) => {
        return Get(_empresa_endpoints['create-empresa'](data))
    }

    const getEmpresa = (data: { id: number }) => {
        return Get(_empresa_endpoints['get-empresa'](data))
    }

    const importEmpresas = (data: Pick<IEmpresa, 'nome' | 'cnpj' | 'nroFilial'>[]) => {
        return Get(_empresa_endpoints['import-empresas'](data))
    }

    return {
        getEmpresas: getEmpresas,
        createEmpresa: createEmpresa,
        getEmpresa: getEmpresa,
        importEmpresas: importEmpresas,
    }
}